import React from 'react';

export const PageSkeleton = ({ rows = 3, rowHeight = 'h-20' }) => {
  const placeholders = Array.from({ length: rows });
  return (
    <div className="animate-pulse">
      <div className="h-10 bg-gray-200 rounded mb-4"></div>
      <div className="space-y-3">
        {placeholders.map((_, idx) => (
          <div key={idx} className={`${rowHeight} bg-gray-200 rounded`}></div>
        ))}
      </div>
    </div>
  );
};

export default PageSkeleton;


